import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';

export var IntegrationDetails = {

	formatPropertyValue(propertyKey, propertyValue) {
		if (propertyValue === null || propertyValue === undefined || propertyValue === '') {
			return propertyValue;
		}
		var upperKey = String(propertyKey || '').toUpperCase();
		if (upperKey.indexOf('PASSWORD') >= 0 || upperKey.indexOf('SECRET') >= 0) {
			return '*********';
		}
		return propertyValue;
	},

	formatAutoUnitLabel(autoUnitId, dataType) {
		return ImportUtil.formatAutoUnitLabel(autoUnitId, dataType);
	},
		
	showDetails(record) {
		
		var detailWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Details',
			icon: 'vaadin:modal-list',
			width: .75,
			height: .75,
			listeners: {
				ready: function () {
					detailWin.show();


					var detailTable = ElementUtil.create({
						tag: 'dl-detail-table',
						itemid: 'detailtable',
						slot: 'primary'
					});

					DataManagementService.getIntegrationService().getIntegrationDetail(record.configId).then(function (detail) {

						var data = [
							{
								key: 'Integration Details',
								value: '-',
								section: true
							},
							{
								key: 'Config Name',
								value: record.name
							},
							{
								key: 'Config Id',
								value: record.configId
							},
							{
								key: 'Company Id',
								value: record.companyId
							},
							{
								key: 'Company Name',
								value: record.companyName
							},
							{
								key: 'Application Module',
								value: record.applicationModuleDescription
							},
							{
								key: 'Status',
								value: record.runStatusDescription
							},
							{
								key: 'Transmission Type',
								value: record.transmissionDescription || record.transmissionType
							},
							{
								key: 'Timing Description',
								value: record.timingDescription
							},
							{
								key: 'Fails Runs Since Last Success',
								value: record.failsRunsSinceLastSuccess
							},
							{
								key: 'System Feed',
								value: record.systemFeed
							},
							{
								key: 'Data Staleness Tolerance Minutes',
								value: (record.dataStalenessToleranceMinutes ? record.dataStalenessToleranceMinutes : 'Default')
							},
							{
								key: 'lastRunDate',
								value: record.lastRunDate ? TimeUtil.formatDateStandard(record.lastRunDate) : "N/A"
							},
							{
								key: 'Warning State',
								value: StringUtil.blankIfNull(record.warningState)
							},
							{
								key: 'Create User',
								value: record.createUser
							},
							{
								key: 'Create Date',
								value: TimeUtil.formatDateStandard(record.createDts)
							},
							{
								key: 'Update User',
								value: record.updateUser
							},
							{
								key: 'Last Update Date',
								value: TimeUtil.formatDateStandard(record.updateDts)
							}
						];

						if (!ElementUtil.isEmpty(record.properties)) {
							data.push({
								key: 'Config Properties',
								value: '-',
								section: true
							});

							for (var key in record.properties) {
								data.push({
									key: key,
									value: IntegrationDetails.formatPropertyValue(key, record.properties[key])
								});
							}
						}

						if (detail.files) {
							data.push({
								key: 'Files',
								value: '-',
								section: true
							});

							detail.files.forEach(function (file) {
								data.push({
									key: 'Config File Id',
									value: file.configFileId
								});
								data.push({
									key: 'Data Type',
									value: file.dataType
								});
								data.push({
									key: 'Data Format Id',
									value: file.dataFormatId
								});
								data.push({
									key: 'Data Filter Id',
									value: (file.dataFilterId ? file.dataFilterId : '') 
								});
								data.push({
									key: 'Auto Unit Id',
									value: IntegrationDetails.formatAutoUnitLabel(file.autoUnitId, file.dataType)
								});
								data.push({
									key: 'Auto Group Id',
									value: StringUtil.blankIfNull(file.autoGroupId)
								});
								data.push({
									key: 'Data Transform Rule Set Id',
									value: StringUtil.blankIfNull(file.dataTransformRuleSetId)
								});
								data.push({
									key: 'Filename',
									value: (file.fileName ? file.fileName : 'N/A')
								});
								data.push({
									key: 'Priority',
									value: file.priority
								});								
								data.push({
									key: 'Run Date',
									value: file.runDate ? TimeUtil.formatDateStandard(file.runDate) : "N/A"
								});
								data.push({
									key: 'Last Data Received Date',
									value: file.lastDataReceivedDate ? TimeUtil.formatDateStandard(file.lastDataReceivedDate) : "N/A"
								});

								if (file.xrefs && file.xrefs.length > 0) {
									data.push({
										key: 'Xrefs',
										value: '-',
										section: true
									});

									file.xrefs.forEach(function (xref) {
										data.push({
											key: 'Mapping Type',
											value: xref.mappingType
										});
										data.push({
											key: 'Xref Value',
											value: xref.xrefValue
										});
										data.push({
											key: 'Source Value',
											value: xref.sourceValue
										});
										
										if (xref.properties) {
											var xrefProperties = [];
											for (var key in xref.properties) {
												xrefProperties.push(key + ': ' + IntegrationDetails.formatPropertyValue(key, xref.properties[key]));
											}
											data.push({
												key: 'Properties',
												value: xrefProperties.join(' | ')
											});
										}										
									});
								}

								if (!ElementUtil.isEmpty(file.properties)) {
									data.push({
										key: 'File Properties',
										value: '-',
										section: true
									});

									for (var key in file.properties) {
										data.push({
											key: key,
											value: IntegrationDetails.formatPropertyValue(key, file.properties[key])
										});
									}
								}

								if (!ElementUtil.isEmpty(file.dataProperties)) {
									data.push({
										key: 'Data Properties',
										value: '-',
										section: true
									});

									for (var key in file.dataProperties) {
										data.push({
											key: key,
											value: IntegrationDetails.formatPropertyValue(key, file.dataProperties[key])
										});
									}
								}
								
								if (file.childFiles && file.childFiles.length > 0) {
									data.push({
										key: 'Child Handlers',
										value: '-',
										section: true
									});

									file.childFiles.forEach(function (child) {
										data.push({
											key: 'Module',
											value: child.applicationModule
										});
										data.push({
											key: 'Format',
											value: child.dataFormatId
										});
										data.push({
											key: 'Input Timezone',
											value: StringUtil.blankIfNull(child.inputTimeZone)
										});
										data.push({
											key: 'Working Company Id',
											value: StringUtil.blankIfNull(child.workingCompanyId)
										});
										data.push({
											key: 'Data Filter',
											value: StringUtil.blankIfNull(child.dataFilterId)
										});
										data.push({
											key: 'Unit Match',
											value: StringUtil.blankIfNull(child.unitMatchId)
										});
										data.push({
											key: 'Auto Units',
											value: IntegrationDetails.formatAutoUnitLabel(child.autoUnitId, child.dataType)
										});
										data.push({
											key: 'Auto Groups',
											value: StringUtil.blankIfNull(child.autoGroupId)
										});
										data.push({
											key: 'Data Transform Rule Set',
											value: StringUtil.blankIfNull(child.dataTransformRuleSetId)
										});
										data.push({
											key: 'GPS Filtering',
											value: (child.gpsFilterId ? child.gpsFilterId : 'Defaults')
										});
										
										if (!ElementUtil.isEmpty(child.properties)) {
											data.push({
												key: 'File Properties',
												value: '-',
												section: true
											});

											for (var key in child.properties) {
												data.push({
													key: key,
													value: IntegrationDetails.formatPropertyValue(key, child.properties[key])
												});
											}
										}

										if (!ElementUtil.isEmpty(child.dataProperties)) {
											data.push({
												key: 'Data Properties',
												value: '-',
												section: true
											});

											for (var key in child.dataProperties) {
												data.push({
													key: key,
													value: IntegrationDetails.formatPropertyValue(key, child.dataProperties[key])
												});
											}
										}
										
									});									
									
								}								

								if (file.units) {
									data.push({
										key: 'Units',
										value: '-',
										section: true
									});

									file.units.forEach(function (unit) {
										data.push({
											key: 'Reference Type',
											value: unit.referenceType
										});
										data.push({
											key: 'External Id',
											value: unit.externalId
										});
										data.push({
											key: 'External Ref No',
											value: unit.externalRefNo
										});
										data.push({
											key: 'Begin Dts',
											value: unit.beginDts ? TimeUtil.formatDateStandard(unit.beginDts) : "N/A"
										});
										data.push({
											key: 'End Dts',
											value: unit.endDts ? TimeUtil.formatDateStandard(unit.endDts) : "N/A"
										});
										data.push({
											key: 'Run Only',
											value: unit.runOnly
										});
									});
								}

							});

						}

						detailTable.updateDetails(data);

					});

					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							detailTable
						]
					});

					detailWin.addToContentElement(layout);

				}
			}
		});
	}
	
};

